function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ActiveAkamaiIcon = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 64 64",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M50.125 46.866h-6.047L49.62 35.78zm.504 5.04l.504 4.535h7.055l-2.52-25.7H45.085l-13.102 25.7h7.055l2.016-4.535z",
                fill: "#f7971d"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M35.007 62.488C21.904 58.457 12.33 46.362 12.33 32.252c0-14.614 9.575-26.7 23.18-30.74C37.022 1.008 36.518 0 35.007 0 16.865.504 2.755 14.614 2.755 32.252S16.865 64 35.007 64c1.512 0 1.512-1.008 0-1.512zm-16.63-23.18v-2.52c0-14.1 11.087-25.197 25.197-25.197 13.102 0 17.134 6.047 17.638 5.543S56.676 5.04 41.054 5.04c-14.1 0-25.197 11.087-25.197 25.197 0 3.024.504 6.047 1.512 9.07.504 1.512 1.008 1.512 1.008 0zM28.96 21.165c6.55-3.024 14.614-3.024 22.677 0 5.543 2.016 8.567 4.535 9.07 4.535s-3.024-6.047-9.575-8.567c-8.062-3.033-16.125-1.5-22.677 3.527-.504.504 0 1.008.504.504z",
                fill: "#0095d6"
            })
        ]
    });
};
const DisabledAkamaiIcon = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 64 64",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M50.125 46.866h-6.047L49.62 35.78zm.504 5.04l.504 4.535h7.055l-2.52-25.7H45.085l-13.102 25.7h7.055l2.016-4.535z",
                fill: "#f7971d"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M35.007 62.488C21.904 58.457 12.33 46.362 12.33 32.252c0-14.614 9.575-26.7 23.18-30.74C37.022 1.008 36.518 0 35.007 0 16.865.504 2.755 14.614 2.755 32.252S16.865 64 35.007 64c1.512 0 1.512-1.008 0-1.512zm-16.63-23.18v-2.52c0-14.1 11.087-25.197 25.197-25.197 13.102 0 17.134 6.047 17.638 5.543S56.676 5.04 41.054 5.04c-14.1 0-25.197 11.087-25.197 25.197 0 3.024.504 6.047 1.512 9.07.504 1.512 1.008 1.512 1.008 0zM28.96 21.165c6.55-3.024 14.614-3.024 22.677 0 5.543 2.016 8.567 4.535 9.07 4.535s-3.024-6.047-9.575-8.567c-8.062-3.033-16.125-1.5-22.677 3.527-.504.504 0 1.008.504.504z",
                fill: "#0095d6"
            })
        ]
    });
};
export const AkamaiIconXS = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 64 64",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M50.125 46.866h-6.047L49.62 35.78zm.504 5.04l.504 4.535h7.055l-2.52-25.7H45.085l-13.102 25.7h7.055l2.016-4.535z",
                fill: "#f7971d"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M35.007 62.488C21.904 58.457 12.33 46.362 12.33 32.252c0-14.614 9.575-26.7 23.18-30.74C37.022 1.008 36.518 0 35.007 0 16.865.504 2.755 14.614 2.755 32.252S16.865 64 35.007 64c1.512 0 1.512-1.008 0-1.512zm-16.63-23.18v-2.52c0-14.1 11.087-25.197 25.197-25.197 13.102 0 17.134 6.047 17.638 5.543S56.676 5.04 41.054 5.04c-14.1 0-25.197 11.087-25.197 25.197 0 3.024.504 6.047 1.512 9.07.504 1.512 1.008 1.512 1.008 0zM28.96 21.165c6.55-3.024 14.614-3.024 22.677 0 5.543 2.016 8.567 4.535 9.07 4.535s-3.024-6.047-9.575-8.567c-8.062-3.033-16.125-1.5-22.677 3.527-.504.504 0 1.008.504.504z",
                fill: "#0095d6"
            })
        ]
    });
};
export function AkamaiIcon(_0) {
    let { isDisabled } = _0, props = _object_without_properties(_0, [
        "isDisabled"
    ]);
    return isDisabled ? /*#__PURE__*/ _jsx(DisabledAkamaiIcon, {}) : /*#__PURE__*/ _jsx(ActiveAkamaiIcon, {});
}
